import { arrayOf, bool, oneOf, shape, string } from 'prop-types'

import { PAGE_TYPES } from 'shared/consts'
import {
  downNavTreeType,
  navItemType,
  upNavTreeType,
} from 'views/utils/propTypes/nav'
import { resultsStateType } from 'views/utils/propTypes/resultsStateType'

const pagePropertiesType = {
  pageType: oneOf(PAGE_TYPES),
  experiments: arrayOf(shape({})),
  coreShopEnvironment: string,
  expa: string,
  ruleContexts: arrayOf(string),
}

export const cmsPagePropertiesType = {
  ...pagePropertiesType,
  shouldShowVariantButtonsOnHits: bool,
  logoPath: string,
  title: string,
  infoText: string,
  topNav: navItemType,
  upNavTree: upNavTreeType,
  secondaryNavTitle: string,
  secondaryNavTree: downNavTreeType,
  declineAllRequests: bool,
}

export const cmsProducListPropertiesType = {
  ...cmsPagePropertiesType,
  searchConfig: shape({}).isRequired,
  searchUrl: string.isRequired,
  searchState: shape({}).isRequired,
  resultsState: shape(resultsStateType).isRequired,
  indexName: string,
}

export default pagePropertiesType
